import { styled } from "@acko-tech/building-blocks.ui.common";

export const Container = styled.div`
  position: absolute;
  background-color: #fff;
  box-shadow: rgb(173, 173, 173) 0px 0px 19px -3px;
  padding: 20px;
  border-radius: 9px;
  overflow: hidden auto;
  z-index: 1;
`;

export default {};
